import React from "react"
import { Box, Collapse } from "@material-ui/core"
import { Blockquote } from "."
import { Icon } from ".."

const HasActiveJobsScheduleChangedBlockquote = ({ show = false, subject = "process", count, mb = 3 }) => (
  <Collapse in={show}>
    <Box mb={mb}>
      <Blockquote
        icon={<Icon name="warning" />}
        title="Schedule change"
        body={
          count > 1
            ? `You have changed the schedule and this ${subject} already has ${count} active jobs running today. If this was unintended, you can manually remove those jobs from the Jobs area.`
            : `You have changed the schedule and this ${subject} already has an active job running today. If this was unintended, you can manually remove that job from the Jobs area.`
        }
        color="warning"
      />
    </Box>
  </Collapse>
)

export { HasActiveJobsScheduleChangedBlockquote }
